/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ITEM_TYPE } from 'utils/constants/itemType';
import { localize } from 'commons/LocalizedText/LocalizedText';


export const TechnicalItemType = ({isTranslated = false, type}) => {
  const theme = useTheme();

  return (
    <Grid container spacing={1}>
      <Grid
        item
        style={{
          color: ITEM_TYPE(theme)[type].color
        }}
      >
        <FontAwesomeIcon icon={faCircle}/>
      </Grid>
      <Grid item>
        {isTranslated ? localize(ITEM_TYPE(theme)[type].label) : ITEM_TYPE(theme)[type].label}
      </Grid>
    </Grid>
  );
};